import { ApplicationBuild } from './applicationbuild';
import { LogManager, Logger } from '../logger/logger';
import * as ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import { RoutingFeatures } from '../../ui/components/navigation/routingfeature';
import { ErrorComponent } from '../../ui/components/navigation/error/errorcomponent';
import { ContextManager } from '../contextmanager';
import * as React from 'react';

export interface PropertyReaderCallBack
{
    onSuccess(propertiesData: any): void;
    onFailure(): void;
}

export class PropertyReader
{
    private logger: Logger = LogManager.getLogger(PropertyReader.name);

    constructor()
    {
        this.logger.log("PropertyReader() invoked");
    }

    readProperty(filename: string, type: string, propertyReaderCallBack: PropertyReaderCallBack)
    { 
        this.logger.log("readProperties() invoked");

        let xmlHttpRequest = new XMLHttpRequest();

        xmlHttpRequest.open('GET', ApplicationBuild.getBaseURL() + filename, true);
                
        console.log("Propert reader :",ApplicationBuild.getBaseURL() + filename);
        xmlHttpRequest.setRequestHeader('Accept', type);
        xmlHttpRequest.setRequestHeader("Access-Control-Allow-Origin", "https://ringtunetb.mpt.com.mm");

        
            xmlHttpRequest.onreadystatechange = () =>
            {
                try
                {
                    if (xmlHttpRequest.readyState ===  4) 
                    {
                        xmlHttpRequest.status === 200 ? 
                        propertyReaderCallBack
                            .onSuccess((JSON.parse(xmlHttpRequest.responseText)))
                                : propertyReaderCallBack.onFailure();
                    }
            }
        
            catch{
                let history = createBrowserHistory();
                history.push("/crbt-web-portal/" + RoutingFeatures.ERROR);
                ReactDOM.render(
                    <ErrorComponent context={ContextManager.getContext()}/>,
                document.getElementById('root') as HTMLElement
           );
        }
        };
        
        
        xmlHttpRequest.send();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/property/propertyreader.tsx